import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Use the `}<Globals name="longName" mdxType="Globals" />{` environment to delete itself`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note`}</strong>{`: An `}<strong parentName="p">{`environment administrator`}</strong>{` performs the steps on this page. See `}<a parentName="p" {...{
          "href": "/dev-guide/admin/plan-installation#roles"
        }}>{`Plan Installation > Roles`}</a>{` for the overview of the roles involved.`}</p>
    </InlineNotification>
    <p>{`Not only can the `}<Globals name="shortName" mdxType="Globals" />{` create the environment, the environment can also delete itself. The
environment is installed using Terraform, which stores the state of the applied modules in the `}<inlineCode parentName="p">{`workspace/{cluster name}`}</inlineCode>{`
folder. Terraform can use that state to delete what it installed.`}</p>
    <p>{`Destroy a `}<Globals name="env" mdxType="Globals" />{` following these steps:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run the following command to launch a `}<a parentName="p" {...{
            "href": "/dev-guide/tools/tools-image"
          }}>{`Developer Tools container`}</a>{`:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`./launch.sh
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the container, change to the `}<inlineCode parentName="p">{`workspace/{cluster name}`}</inlineCode>{` directory:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`cd workspace/{cluster name}
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the container, run the `}<inlineCode parentName="p">{`destroy.sh`}</inlineCode>{` script to apply the Terraform destroy:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`./destroy.sh
`}</code></pre>
        <p parentName="li">{`Rather than directly running `}<inlineCode parentName="p">{`terraform desroy`}</inlineCode>{`, the `}<inlineCode parentName="p">{`destroy.sh`}</inlineCode>{` script first builds a “destroy plan” from the current
state then applies that plan. Performing the destroy in this way is more reliable and allows for certain resources
to be selectively destroyed/saved.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      